module.exports = __webpack_public_path__ + "img/ai_text_shorter.17955b44.svg";